"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rightOffset = exports.bottomOffset = exports.width = exports.arrowSize = exports.portalId = exports.classes = void 0;
var classes = {
  container: 'bds-back-to-top-container',
  arrow: 'bds-back-to-top-arrow'
};
exports.classes = classes;
var portalId = 'bds-back-to-top-modal';
exports.portalId = portalId;
var arrowSize = 32;
exports.arrowSize = arrowSize;
var width = 56;
exports.width = width;
var bottomOffset = 96;
exports.bottomOffset = bottomOffset;
var rightOffset = 16;
exports.rightOffset = rightOffset;